import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import TypeCircleChart from './TypeCircleChart';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import formatEventName from '../../../services/MeTicketAdditional/FormatEventName';

function TicketTypeSales({ data }) {
  const {t} = useTranslation()

  const [circlesArray, setCirclesArray] = useState([])
  const [titlesData, setTitlesData] = useState([])

  const [totalAmountOfSold,setTotalAmountOfSold] = useState(0)
  const [totalNumberOfTickets, setTotalNumberOfTickets] = useState(0)
  const [title, setTitle] = useState(undefined)
  const [description, setDescription] = useState(undefined)

  const isNoPeriodData = useSelector(
    (state) => state.meTicketData.isNoPeriodData
  );

  useEffect(() => {
      setTitle(t('ticketStatistic.eventSales'));
      setDescription(t('ticketStatistic.eventSalesDescription'));
      if (data.eventsToTicketsStatistic) {
        const eventsArray = Object.entries(data.eventsToTicketsStatistic).map(
          ([id, event]) => ({ id: parseInt(id), event: event })
        );
        setTotalAmountOfSold(
          eventsArray.reduce((acc, el) => acc + el.event.total_sold_tickets, 0)
        );
        setTotalNumberOfTickets(
          eventsArray.reduce(
            (acc, el) => acc + el.event.total_created_tickets,
            0
          )
        );
        setCirclesArray(eventsArray);
        setTitlesData(data.events);
      } else if (data.singleEventsTicketsStatistic) {
        setTitle(t('ticketStatistic.typeSales'));
        setDescription(t('ticketStatistic.typeSalesDescription'));
        const eventsArray = Object.entries(
          data.singleEventsTicketsStatistic
        ).map(([id, event]) => ({
          id: parseInt(id),
          event: {
            total_sold_tickets: Object.values(event).reduce(
              (acc, el) => el.sold + acc,
              0
            ),
            total_created_tickets: Object.values(event).reduce(
              (acc, el) => el.created,
              0
            ),
            ticket_left:
              Object.values(event).reduce((acc, el) => el.created, 0) -
              Object.values(event).reduce((acc, el) => el.sold + acc, 0)
          }
        }));
        setTotalAmountOfSold(
          eventsArray.reduce((acc, el) => acc + el.event.total_sold_tickets, 0)
        );
        setTotalNumberOfTickets(
          eventsArray.reduce(
            (acc, el) => acc + el.event.total_created_tickets,
            0
          )
        );
        setCirclesArray(eventsArray);
        setTitlesData(data.tickets);
      }
  }, [data, t]);
  return (
    <Col
      xs={12}
      lg={12}
      className={classNames({ 'opacity-25': isNoPeriodData })}
    >
      <div className="border rounded-1 p-4 mb-4 col-12">
        <div className="d-flex justify-content-between mb-3 mb-lg-2">
          <div>
            <Row>
              <h4>{title}</h4>
            </Row>
            <Row>
              <small className="opacity-50">{description}</small>
            </Row>
          </div>
        </div>
        <Row>
          <div className="d-flex flex-lg-row flex-column gap-2 mb-4 mb-lg-5">
            <div className="d-flex">
              <i
                className="bi bi-cash-coin ps-2 opacity-50 pe-1"
                style={{ fontSize: '14px' }}
              ></i>
              <p className="mb-0">
                <span className="opacity-50 pe-1">
                  {t('ticketStatistic.soldTickets')}:
                </span>
                <b className="text-primary">{totalAmountOfSold}</b>
              </p>
            </div>
            {/* Hidden for this release: total is inflated by recurring events
            <div className="d-flex">
              <i className="bi bi-ticket-perforated ps-2 pe-1 opacity-50"></i>
              <p className="mb-0">
                <span className="opacity-50 pe-1">
                  {t('ticketStatistic.totalNumberTickets')}:
                </span>
                <b className="text-primary">{totalNumberOfTickets}</b>
              </p>
            </div>
            */}
          </div>
        </Row>
        <div className="d-flex col justify-content-between flex-wrap gap-4">
          {circlesArray.map(
            (el, index) =>
              el.event.total_sold_tickets > 0 && (
                <TypeCircleChart
                  key={index}
                  index={index}
                  eventData={el.event}
                  title={data.events
                    ? formatEventName(
                      titlesData[el.id] || el.id,
                      el.id,
                      data.eventMeta,
                      t('ticketStatistic.archive')
                    )
                    : titlesData[el.id] || el.id}
                />
              )
          )}
        </div>
      </div>
    </Col>
  );
}

export default TicketTypeSales
